const CHART_SELECTOR = ".js-chart";

function init(): void {
  if (document.querySelector(CHART_SELECTOR) !== null) {
    // If a chart block exists

    const head = document.getElementsByTagName("head")[0];

    const js = document.createElement("script");

    js.src = "/scripts/amcharts.js";

    head.appendChild(js);
  }
}

export default { init };
